import { Button } from "@beweegbaas/ui";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useImportStepperItems } from "#/modules/school.import/components/import-stepper";
import { ImportTableClasses } from "#/modules/school.import/components/import-table-classes";
import { ImportTableStudents } from "#/modules/school.import/components/import-table-students";
import { getImportReviewStatusData } from "#/modules/school.import/import.functions";
import { useImportData } from "#/modules/school.import/use-import-data";
import { isValidStudentStatus } from "#/modules/school.import/utils";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/detail/import/$type/review/$status",
)({
  loader: ({ params }) =>
    getImportReviewStatusData({
      data: {
        school: params.school,
        type: params.type,
        locale: params.locale,
        status: params.status,
      },
    }),
  component: ImportReviewStatus,
});

function ImportReviewStatus() {
  const { status } = Route.useParams();
  const importData = useImportData();
  const { getNextStatusLink } = useImportStepperItems();

  if (!status) {
    throw new Error("No status found in URL");
  }

  return (
    <>
      {status === "klassen" ? (
        <ImportTableClasses parsedClasses={importData.klassen} />
      ) : isValidStudentStatus(status) ? (
        <ImportTableStudents parsedStudents={importData[status]} />
      ) : (
        <div>Invalid status: {status}</div>
      )}
      <div className="flex justify-end">
        <Button
          type="button"
          variant="secondary"
          size="xl"
          render={<Link {...getNextStatusLink(status)} />}
          nativeButton={false}
        >
          Volgende
        </Button>
      </div>
    </>
  );
}
